import React, { useContext, useMemo } from "react";
import { FiHeart } from "react-icons/fi";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import siteConfig from "../config/siteConfig";
import "../css/account.scss";
import { CartContext } from "./CartContext";
import PageMeta from "./PageMeta";
import ProductCard from "./ProductCard";

const catalogById = new Map(
  productData.map((product) => [String(product.id), product])
);

function Wishlist() {
  const { wishlistItems } = useContext(CartContext);
  const savedProducts = useMemo(
    () =>
      wishlistItems
        .map((item) => catalogById.get(String(item.id)))
        .filter(Boolean),
    [wishlistItems]
  );

  return (
    <main className="wishlist-page">
      <PageMeta
        title="Wishlist"
        description={`Your saved pantry favorites at ${siteConfig.brandName}.`}
        noIndex
      />

      <header className="wishlist-hero">
        <div className="account-shell wishlist-hero__inner">
          <div>
            <p className="account-eyebrow">Saved for later</p>
            <h1>Your wishlist</h1>
            <p>
              Keep the ingredients, small luxuries, and gifts you would like to
              find again.
            </p>
          </div>
          <span className="wishlist-hero__count" aria-live="polite">
            {savedProducts.length} {savedProducts.length === 1 ? "favorite" : "favorites"}
          </span>
        </div>
      </header>

      {savedProducts.length > 0 ? (
        <section className="account-shell wishlist-results" aria-label="Saved products">
          <div className="wishlist-results__heading">
            <h2>Saved from the pantry</h2>
            <p>Select the heart on any product to remove it from this list.</p>
          </div>
          <div className="wishlist-grid">
            {savedProducts.map((product) => (
              <ProductCard key={product.id} product={product} tone="cream" />
            ))}
          </div>
        </section>
      ) : (
        <section className="account-shell wishlist-empty" aria-labelledby="empty-wishlist-title">
          <span className="wishlist-empty__icon" aria-hidden="true">
            <FiHeart />
          </span>
          <p className="account-eyebrow">A table waiting to be set</p>
          <h2 id="empty-wishlist-title">Nothing saved just yet.</h2>
          <p>
            Tap the heart beside any product and it will be waiting for you here
            on this device.
          </p>
          <Link to="/shop">Explore all products</Link>
        </section>
      )}
    </main>
  );
}

export default Wishlist;
